const TSTAT = ['pending', 'processing', 'completed', 'failed'];
const MSTAT = ['pending', 'draft', 'approved', 'failed'];

export const transcriptQueueSeed = Array.from({ length: 28 }, (_, i) => ({
  id: `tq-${4000 + i}`,
  meetingId: `mtg-${3000 + (i % 40)}`,
  meetingTitle: `Sync / Review ${i + 1}`,
  provider: i % 2 === 0 ? 'Microsoft' : 'Google',
  transcriptStatus: TSTAT[i % 4],
  momStatus: MSTAT[i % 4],
  ownerEmail: `owner${i % 6}@acme.example`,
  meetingDate: new Date(Date.now() - i * 86400000).toISOString(),
  failureReason: i % 4 === 3 ? 'Timeout contacting transcription service' : null,
}));

export const momEditorSeed = {
  meetingId: 'mtg-3000',
  meetingTitle: 'QBR / Sync — Alpha',
  meetingDate: new Date().toISOString(),
  organizerName: 'Sara Al-Hinai',
  transcriptSpeakers: [
    { id: 'sp1', speaker: 'Sara Al-Hinai', time: '00:02', preview: 'Thanks everyone for joining today…' },
    { id: 'sp2', speaker: 'Ahmed Al-Balushi', time: '00:45', preview: 'On the budget line we are…' },
    { id: 'sp3', speaker: 'Priya Menon', time: '01:12', preview: 'I’d like to flag a risk on…' },
  ],
  summary: 'Team aligned on Q2 targets; budget approved pending legal review.',
  decisions: ['Approve budget v2', 'Defer vendor contract to next week'],
  actionItems: [
    { id: 'ai1', what: 'Send revised SLA to vendor', assigneeId: 'u-2', assigneeName: 'Ahmed Al-Balushi', dueDate: new Date(Date.now() + 5 * 86400000).toISOString().slice(0, 10) },
    { id: 'ai2', what: 'Schedule follow-up with finance', assigneeId: 'u-1', assigneeName: 'Sara Al-Hinai', dueDate: new Date(Date.now() + 2 * 86400000).toISOString().slice(0, 10) },
  ],
  risks: 'Vendor may miss June milestone if contract not signed.',
  nextSteps: ['Legal to review by Friday', 'Publish MOM after approval'],
  approverId: null,
  approverName: null,
  status: 'draft',
  versions: [
    { id: 'v1', label: 'v1 (AI generated)', author: 'AI', at: new Date(Date.now() - 86400000).toISOString() },
    { id: 'v2', label: 'v2 (edited by Sara)', author: 'Sara Al-Hinai', at: new Date(Date.now() - 3600000).toISOString() },
  ],
  assigneeOptions: [
    { value: 'u-1', label: 'Sara Al-Hinai' },
    { value: 'u-2', label: 'Ahmed Al-Balushi' },
    { value: 'u-3', label: 'Priya Menon' },
  ],
};

export const actionItemsSeed = Array.from({ length: 24 }, (_, i) => {
  const due = new Date(Date.now() + (i - 8) * 86400000);
  const overdue = due < new Date() && i % 5 !== 0;
  return {
    id: `act-${5000 + i}`,
    description: `Follow up on action ${i + 1}: ${['SLA', 'Budget', 'Vendor', 'Training'][i % 4]}`,
    meetingId: `mtg-${3000 + (i % 12)}`,
    meetingTitle: `Meeting ${(i % 12) + 1}`,
    ownerId: `u-${(i % 4) + 1}`,
    ownerName: ['Sara Al-Hinai', 'Ahmed Al-Balushi', 'Priya Menon', 'James Cole'][i % 4],
    dueDate: due.toISOString().slice(0, 10),
    status: overdue ? 'overdue' : ['open', 'in_progress', 'completed'][i % 3],
    priority: ['low', 'medium', 'high'][i % 3],
    notes: [],
    statusHistory: [
      { at: new Date(Date.now() - i * 3600000).toISOString(), status: 'open', by: 'system' },
    ],
  };
});
